import * as yup from 'yup';

import { cellphone } from './cellphone';
import { name } from './name';
import { telephone } from './telephone';
import { telephoneOrCellphone } from './telephoneOrCellphone';

yup.addMethod(yup.string, 'cellphone', cellphone);
yup.addMethod(yup.string, 'name', name);
yup.addMethod(yup.string, 'telephone', telephone);
yup.addMethod(yup.string, 'telephoneOrCellphone', telephoneOrCellphone);

yup.setLocale({
  mixed: {
    required: 'Campo obrigatório.',
  },
});

export * from 'yup';
